export const Bio = {
    name: "Hariprasath C",
    roles: [
      " Java Full Stack Developer",
      "Web Developer",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/hariprasath8111",
    resume:
      "https://drive.google.com/file/d/1sGGU3LkTZtsGYMRqESoHP1fj7mDJYrPe/view?usp=sharing",
    linkedin: "",
    insta: "",
    
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
       
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
       
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Java",
          image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Spring Boot",
          image:
            "https://img.icons8.com/?size=48&id=90519&format=png",
        },
        {
          name: "Oracle Sql",
          image: "https://e7.pngegg.com/pngimages/1021/283/png-clipart-microsoft-sql-server-oracle-database-oracle-corporation-sql-logo-purple-text-thumbnail.png",
        },
      ],
    },
   
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://w7.pngwing.com/pngs/192/492/png-transparent-git-bash-hd-logo-thumbnail.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Eclipse",
          image:
            "https://w7.pngwing.com/pngs/631/720/png-transparent-eclipse-foundation-integrated-development-environment-ceylon-java-eclipse-miscellaneous-logo-electric-blue-thumbnail.png",
        },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://w7.pngwing.com/pngs/28/245/png-transparent-postman-hd-logo-thumbnail.png",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/v2/D4D0BAQFsM4OuVleklg/company-logo_200_200/company-logo_200_200/0/1702576029790?e=2147483647&v=beta&t=Mtvoveo1GPPJelnZTfouTMcNppRqPI53jn_is0AFn4I",
      role: "Web Development Intern",
      company: "VeriTech Software IT Services",
      date: "Jan 2024 - April 2024",
      desc: "Engaged in code reviews and collaborated with senior developers on feature design.",
      skills: [
        "HTML",
        "CSS",
        "JavaScript",
        "GitHub",
      ],
      doc: "https://drive.google.com/file/d/11PW1tz75x-wF8dsAL0quvrqrTgB2BmKc/view?usp=sharing",
    },
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/v2/C4E0BAQHWgv26_a460Q/company-logo_200_200/company-logo_200_200/0/1638253642615/tehchnosprint_info_solutions_logo?e=2147483647&v=beta&t=JU8tUqMjja2XoTLN_8t_tT5szLkuKhYNnnxngfDD6IA",
      role: "Frontend Intern",
      company: "Technosprint Info Solutions",
      date: "Dec 2022 - Jan 2023",
      desc: "Working on the frontend of the web application.",
      skills: [
        "HTML",
        "CSS",
        "JavaScript",
      ],
      doc: "https://drive.google.com/file/d/11_UWPwxQ1kiuodT9oVm9A7Di4xAvu4ST/view?usp=drive_link",
    },
 
  ];
  
  export const education = [
    {
      id: 0,
      img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAHgAWgMBEQACEQEDEQH/xAAbAAACAwEBAQAAAAAAAAAAAAAABgQFBwMCAf/EADgQAAICAQQABQIEBAQGAwAAAAECAwQRAAUSIQYTIjFBFFEyQmFxBxVigSNSobElM3Ki0fAWNJH/xAAZAQADAQEBAAAAAAAAAAAAAAAAAQIDBAX/xAAuEQACAgEDAQYFBAMAAAAAAAAAAQIRIQMSMUEEIjJRYfATkaGx8UJxgcEj0eH/2gAMAwEAAhEDEQA/ANx0AGgA0AGgA0ALS3B/8/aqZ+v5aSIgTjkJASce2cMNKs2XS2fyMumQGgA0AGgA0AGgA0AGgA0AGgDx5iNy4MrFeiFOcH7aAMbu+JJzuv10dS6NyV/LjxXPMyE/8s/0k+nB+O8Z1v8ADXwd1l33tvT3k2GSzFDEr2ZEhDYA8xgvf27+dYEHUEMMqQQfkaAPugA0AGgA0AGgA0AVe+73Bs0UbTY5ykiMMcAkDPZ/8ZOhJt0hr1F2/wCJhu/hbdVgSSruVWNTNWY4cAkEFfuCM4+fjVONNXwVFZVZF3w1u1qr4ljnr17ElSaJo7MQK5CjtH4jpcHIJyfxd/Gqmo1jlEqW7DKjdZbc/wBSE4czOZlJDcg4fkDnljIx7401JKO339hOVTvoMXizdrdy1UsCs6VRGAivKqtk9k4wwORj3Gp06XP+xye1UmTPC3iKHa/BNRpJ45LTyyiOF5FBTlIxUN310R9vt1pbW5uKKkurL7wt4il3ee1TswcLFRUZ3VSqnnnAwewfT+o7BB70mmiXXKGPSEGgA0AGgCg8V76+0JWhhVvqLZZIW4ZBYDPH7ZP69YBPxpxVsa82Ju9+JI9/2V604aG/WmWStbrf8tyMglc9gYLL/fIOrUXCS9/Mdxp5KU1qkW3LbgxHNGxinUnLNyOVK/JyeiOzn99Hek6M02lgtdg2bxBJK09XbRCjxPH5l5hGPUPcJgk4OD2BpuMV4mCTEu9hNzsCxePmo8nIIx4ckcD2xnicN17/ANtd8YrZSXkS1k0DfNi8QT1q7pSr20RFwatjDEcQBhHA+3+bXAlDzopplJTNWFbkW51288KqipKpjlyfzd/lAz32DkDRJSikLpR38Nb23hzbbtetV5yzT+aJVbvjgAKFPXpAAHxpS78rbLUo1kZfAe9Xtx3W5X842qUUaySTuxPGVvZVz2Mrksp/Cf0OpnHa6HzGx51Ig0AV2/7pFs21y3ZmRVXChnOFDMcDkfgZOjPCGlbM+3zxG270bO1btTinR0DxywsY2ib8jd/OMHHwD37602ONNMalEoIY5p5oKlOIz2pjwijHXL9SfhQOydOMdzzhGRpXhXwpS2lVszslzcSMPYI6jP8AlQflH+p+dRLV3Ko4RSQzagZhsnCxukJ/EZ4rLeXgFH5ODkn8XH5Yj2wcfOfSyoP+CHybD4dsi5sVCxyDeZXRuS+x6+NcE1Umi0c9+2jbN5hSruKIZDkwsG4yIfuh99EZOHAUZhvO03NivipdIlR8mvZC4EwHwR8OPkfPuP0tpNbofL30IaOuyb5b2TbRt9eSOGu07uZwg5rz7y5/MA3uejj9tJQUpe/uXvVZQ8eAd3t7xt1iacSPXWYivYkI/wAUY9QB/MFbKhvzADUSSTpDY0aQhf8AEG/bfVM1G7VezGYz5ycQU4lSSDn+kE6ai5cIpKs3Rl0kFOGzMNs+oFN2DRR2G5NHkdjPvj986tt1nkidXgbvBVKajtEviIRI8lnpA7H0Vh+Ej9zlj+hH21l2zUlpRqK45J4Vl7tM8MoeE11EqEli0vAtnv49/f8A2152hKMk01letBF2St23WvtmyW5rEsSGOMqixsWwxBCj9yetehoLc1FFmUo0KeTK7MWgSOMII3BfIIfDAejOE6H4cnPu2fSp5Xv0ING/h5ucVnaHpB3eeq7c8wlBxZiVx0Bj39vtrl1o1K/MpM5X/wDifiqxRF5oQIEETKiMBICSR2Mhh79Ee2ksQujZYhdEe3S3fxN9btG4GqkdM9WVjIYzY5RuvfXwSPsSPnTUowqS6inGG211M+miazVaKxGqyq+JYnGVDo3qU/cZBH7HSlFRlXQxi6djvD45mhiik+lqQ045REyAFeCh0UgHOM8X5AY7AOocGo3Zotrx1ND1JIheN/D9e1Ynt1N6SlaljKzQTDzUkGAMhc5U4AGRpx1HHgtLcqoVL58zaWR6/ktPFHHB/gFWEjYVmD/mHZ/fI+2tdOPfSMmuhp+7RivtcFCshIYpEqIPyj/T415/a5NxpcsJcHOhUP1oF6shLLyRjGoAI+2Pns6jS0+/34gkVf8AE+3HR8KPEIg72bEUSRL6S55A4GPnCnXp9mh/kxgbwjM2qw8JVvbikVqQqTHAoVYz9lBPt/77a7U3zFYIobv4Y7g9bfNy224sEbyQJYR4vSkgUkFgPjoqMfodc/aI3BSRS5o92LzWLKsZ2qV4rDyhePrRMhw4JHZ9ROP7d6z2pI61GkOXh6pLXe5LPagsSzy83aE+/vgkfHWBj7LrKb4MZuxH32GCl4w3NXVB5oisxGRCyhjgNkD78D8auWYRf8GT5Ofh5fDsNuS9ula1PfScyBmTMaDJCOsWcLkDHtn31ElJ/saLKqLNRqzxWq0ViBw8UqB0cfmUjIOpJMx8SbF4jN66IdnW5XlnMsU8dpQePmc8MrexAyOtXHUUY1Q2lLqV9+030a2ZYhC7zQWZYntB2Xiwb0qB6Rg95Pt1q9OlMiSrBqG615LTV/p8clLNyLFQBj7jv3xrg19OU6roN5OEdC5XmineTzuDDI5MSPg4HtrOOjqRak3YqYj/AMU7VizulZKqiSLaik0sfH8buegP1Cj2/q17PZUlF31CQoy7W24m1brX6P08/DnyUB04nPz+E/fGt1qKNJp2ias61pZxuy7hSb/DpQFOaoSbAclW4r8j37+4HR+E62U+pUcSTNEbw7uFiQ2A0UgmUZYynDrgYyB79Aa496WDpWpFFnsWy3aN9Z7DwiNYTHiPOWyQRn9sH/8AdRKSawRKSawKHjDcBV8b2JVq2LXl14o2SvJwOcMez9ux186JOtON+pEYuUsHHZtr3LxNamupvabZLK2Pp5oBLZCIem7IAzk/lwBjSWpWEU4KPiXv36mmbbtsG37dVpQmQx1oUiQs5JIUADP69ahKlRDy7Yk/xB3uenuDUbNs1a0sAaFgpwxIYEnA74sE6+zauGz9RSuu6hUimq7lTRRHNPasR8JEfKmP4GExk9exPWndO0RJNcmn+CtzO5bFEs5xcqE1rSfKyJ0cj9Rg/sdGrGpWuHkEyXv+9VtjqpYtxzPG78B5ScvVjIz9vbShBzdIdmSybmtmSS3eSwXkEs0uAGw7KeKHv8AbgeusIM5Ou5QawiGyTatbXINukkoiaRokUlqZJk9AHygz2PcltS1qK0n9R4OEu5oZbHl1LPnx3D2YsLwMYUqwJB6PEj2PXRGdUtOVK/ILQ3eAvEb4q7FLTsekukEzuvUSjIDd5yAcfPWP11hr6Vd+wTHmxNFWryTTuqRRoXdmPSqBknXMleEUZEu6QFNw3fdYnVbzNYUvHyXy8MI0OPUvSg9dnjrbU8W1dCVlnhNh8Q2Q6Dw9PWlnbkliOaMLBlVVSDy5enLtj741L1FtpGkVtd2bGg4oq5JwMZPzrMkj7naWjQsW2ieUQRtIURSzHAz0BpMaVujKN48SGHcGu25oedmHgnlAFgFPIDAyWQqc/Yhjn21s4pR59+gNt4SJ2235tgvNuSPLZjdY4rUSgFZlAHExfLOgYf8AUp+etCqS2P3/AMI4D+Ivi2hcSnUpTedAMTyWIkJAYg8Vz1g4JJHuOh1nW/Z9GStsG0KcS2BF5luGXNl8iIyDkqt+HkOQwCOxnAORj447tq6T4Ehl8P8Ahldz257dhMgEjyzYeLgADkYA7zn/AEH21yanadkmkbR0rSfmL7RRraMMaK8Tvx5+YCFyelPz1kj2PsP7dClasyap0fNq3K3sG4VZI6Us9muFkVoiJFmhfOBy+Mgkf9Q/fVygtSPOCboc/EHiSv4nEVKi7DaCR9RO2YxYkxlYOR/CMj1MevjvvXFtejzyVdlFuNi6kM9Nqk9iGLEU9yKqzGurADDKOyeCjHRIUjOOWoi4p5KUJUNn8Nb1u212KOSSbaognkvMG5RSHJMQJ7YBeJP2LED21MmrwU7pXyPOkSR69ytaeaOCVXeFuEgH5T9jpWNprkXt0p7N4T26e7tu1069idhGrpEq8nc4ALH4z9zjOBoUc0O3Lkz6lfFHcFplJJ2gidoVhUkVlycsYyQVIwQVzke4z1rpelatGbbbsjSwNuslmStZFb6qFvOlHqVo8Akt1knAA5D1H504ar02lJXQhq8K3dt2oqLW1SSWPKEgux4dOLHHpBIKd/GCf1Op1Hv4ZSIDSU7xJO4xvuAnaYzCNz+b2ZPL7GMDs461phPjA03xZZbbu230drsQTU7G7PYkcycawjhyi/hy2ACFGeh+3xrOSzd0Kxbl2yKWeW1KhirNGjWKMMhYGF+JALk5fHpPtgHrJxq3r0qj8yT3c3Z4K9ijWrVrb14eMnBVUyQ59LIPcsvv9gP194houatuvf0BvoT/AOHu4Mu/wxbbObUdoMb0ak4jwMiTB/AAcIM9vknGF1GptxRok0qZqNuxHUqy2Zc8IkLtgd4AzrMErdIoZPGVOGRopqO4rIhKuogyAR79g96j4iNfgT6fcibHbpx+KVrVJjItjblBkwcSPG5ywP5s+Yex9tCw6Ic1ONro/v8AgYt5kqR7bOL8aSwSKUaJwCJM/lwdWSrvBkW6Rbf9Bdh26txrqVjcwwlkLMwCqp/E7Zz79kjAPvrq018LvSeQk3PCO+wbNa3e+V2a1PTo1/TLZEXmcW9hEocZPv6ww9OMZ1lOcXlci27eSLLuN+rTnlkEk3mFEM0UYAkwSqIACQuSQMH9NLbixNd7ajvXls7Rdnr7lTkgm8rg0QZZOmwQQQCPj5GlGLkrQNUFTcNzhrVrUNArSvTyfTs8iv5hAIKsvQHSkj2xx0JJtoe2lZ32PZb+/wBfc68W6zRTUhG1WssitAeQJ9ZAOSSG+cDIOnLuyXUaSrJFTb7UFiGZ9qtUeJaCSW0AqCU9qrOT68kY5YCerA7xrWGrF93+hbKzYx+F93XYZGS3SkqUJGUOJgM1Ce1Af3ePBHv2uft7Z6kc2ir3fuN/iify9lkCYJlKqO/cZyf+0HWEuAhh2+gv/wA831uzt0Pff/13b/UHvRfocy1ZkMGF3ju1SIFLNOJIUKLUC5BL5BLSe6FT0O1A1PPBvnRm01a/r3wdN6j3Td7EDC7BE0K48pVGS3fq8uRl4no9ZPt79apSlE0T02sP5/hkfZtmmqbtUtXLYty1lZa0FhkQIWx6+Ks5ZgGPf9ZPzpucpcoHsXX39Bjo7xPNe20CxFYr3jKOKxcOPFeXIdk4+O/uPbStkra42iJW8AUIN3rXDbnlrVpPNipyInFX74+oKGIUnIBJwQPtq90mtreA3eh08TeGL247kLu1XYKzvEI5hMkjAkE8WHB17GSO8/GhSceBKqySh4Spv4Tr+H55HeOCNAs4A5iRe/MGcjPLJ/vpJtO1yF5s4ttkHhihNZgs2pJZ5YltXLEnmSBM8cjrAAz7AYGfbUydKyo1J5Ko7hJum326lywrU7CSchZiziLrvkuCG9Sj2OG6+DpJszjqweWq9+pWSeGdskHCa7LyJCNGtiWV/wAJYAgKpHQOAf21fxNTzLc9Nfgs4RBbrR06duB4YqwEYuZKTxD0lB/lHpwx7YdZ+2oRnKa1FUeH9RcFnZCAY6++FD+EwbWk0eP6ZPL9Y+zfI70rQ12SVeKvkP8AvHh155ZbO1WBWmmKtPDIpaGdlIIYgEFXGB6h/cHVNeRpuTjtlwUlulu72RNuXh+S0RM0zfS2Y5FY8QqgcyhAGM40s+RD0oSfiI8O173YijT+RAERQoJLdhIeBjBUOPL5sG4nH9hoViWlD9Tv9kSoKtzatzs7hP8ARedWB9EKycG89gSveSG5KDkD8x60s2af44w8rfv7l/Bv4fgHqk84xKDBKsg4EZDYJBx/bVbvQlKL8MkSRvVQY8wWIyfh68gP+2jcivhyBt1DHFepYkPfbL5Y/wC7H+2jcLbXLKe5uy7l5VN3hijsnijIxYMwwQvLAAPsce5B60nbFHUhGSp2V9Pat63jZo7n8xpStcriOxDPS4dd8o+St0ORYfhOhW0VOOnbi0Sv5T4jkmlZo9pj5TRyq/nSvxKKAvXEZHXffydOmRsh6net4QEw/wCO3PrULc2rRRCGBmxjLLkl+gB6mIOB1o2+ZSko+FUM6oqqFUYUDAA6A1RJ60AGgA0ALfiDZL9qeSfb5YHSUKZa05ZAWX8LLInan9wfYHrUtMq4tVIpLNfd4otwSfw7OFtVhWU0po5lhAXivEEqcDv4z3pZ8iXpRd1L6fk+2N0eHc68023b3FUwsZT6Rzk8XBT0kjLFlOfb0++jcC0nu8SoKcm6hduSv4bvyPUEqSPYkjiV1cEYyWLfCk9ffTt+QR0opK3wd6Hh3f2g8l3obdEWU8hm1MAqqq4JCoCAq9lW7GdFMcY6cOMjbtdGLbKENKvzMcK8Qztlm+5J+STkn99NKgbt2StMQaADQB//2Q==",
      school: "IFET College of Engineering,Villupuram",
      date: "Aug 2019 - May 2023",
      grade: "7.41 CGPA",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
      degree: "Bachelor of Engineering - Electronics and Communication Engineering",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPk9-_h8CL8D4zlnlQHxsyKfdOjThx04W07Lf32JDsMg&s",
      school: "S.R.K Higher Secondary School,Puducherry",
      date: "Apr 2018 - Apr 2019",
      grade: "74%",
      desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
      degree: "XII, Computer Scince",
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPk9-_h8CL8D4zlnlQHxsyKfdOjThx04W07Lf32JDsMg&s",
      school: "S.R.K Higher Secondary School,Puducherry",
      date: "Apr 2016 - Apr 2017",
      grade: "90%",
      desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
      degree: "X, State Board",
    },
  ];
  
  export const projects = [
    {
      id: 9,
      title: "Weather Finder",
      date: "Jun 2023 - Jul 2023",
      description:
        "The Weather finder project is a web application that leverages HTML, CSS,JavaScript and React js to fetch weather data from a weather API and display current weather conditions and forecasts for a specific location",
      image:
        "https://cdn.icon-icons.com/icons2/8/PNG/96/cloudyweather_cloud_inpart_day_wind_thunder_sunny_rain_darkness_nublad_1459.png",
      tags: [
        "HTML",
        "CSS",
        "JavaScript",
        "React js",
        "Github",
        "Node Js",
        
      ],
      category: "web app",
      github: "https://github.com/hariprasath8111/WeatherFinder.git",
      webapp: "https://fff04a0c.hariproject1.pages.dev/",
    },
    {
      id: 1,
      title: "Portfolio Website",
      date: "Oct 2022 - Present",
      description:
        "Designed and developed Portfolio Website, to create a responsive personal portfolio website using HTML, CSS, javascript, and React js.",
      image:
        "https://tse3.mm.bing.net/th?id=OIP.1INcHJRNQ2egYzqErzr_KAAAAA&pid=Api&P=0&h=180",
      tags: [
        "React Js",
        "HTML",
        "Node Js",
        "CSS",
        "Javascript",
        
      ],
      category: "web app",
      github: "https://github.com/hariprasath8111/portfolio.git",
      webapp: "",
    },
    {
      id: 2,
      title: "Netflix Sign ",
      date: "Jan 2023 - Mar 2023",
      description:
        "The Netflix clone project is a web application developed using HTML, CSS, aiming to replicate the user interface and some features of the popular streaming service",
      image:
        "https://tse1.mm.bing.net/th?id=OIP.3FCiWol8fLRLFWVRP1SpMAHaEK&pid=Api",
      tags: ["HTML", "CSS",],
      category: "machine learning",
      github: "https://github.com/hariprasath8111/Netflix.git",
      webapp: "https://musical-hotteok-e01381.netlify.app",

    },
   
    {
      id: 10,
      title: "Travel Management Website",
      date: "Jun 2023 - Jul 2023",
      description:
        "This project delivers a travel website that inspires wanderlust through vibrant imagery and key destination highlights.",
      image:
        "https://repository-images.githubusercontent.com/565274109/421bdd94-cf9b-48aa-8777-b617c466482c",
      tags: ["HTML","CSS", "JavaScript", ],
      category: "android app",
      github: "https://github.com/hariprasath8111/Web-dev-task-2.git",
      webapp: "https://astonishing-licorice-a44af2.netlify.app",
    },
    {
      id: 3,
      title: "To - Do App",
      date: "Dec 2021 - Apr 2022",
      description:
        "Todo Lists are the lists that use to maintain our day-to-day tasks or list of everything  with the most important tasks at the top of the list, and the least important tasks at the bottom. ",
      image:
        "https://static.vecteezy.com/system/resources/previews/000/411/286/original/vector-people-making-a-to-do-list-illustration.jpg",
      tags: ["HTML", "CSS", ],
      category: "android app",
      github: "https://github.com/hariprasath8111/Todo-list.git",
      webapp: "https://celadon-taiyaki-99c3b6.netlify.app",
    },
   
  ];
  
  // export const TimeLineData = [
  //   { year: 2017, text: "Started my journey" },
  //   { year: 2018, text: "Worked as a freelance developer" },
  //   { year: 2019, text: "Founded JavaScript Mastery" },
  //   { year: 2020, text: "Shared my projects with the world" },
  //   { year: 2021, text: "Started my own platform" },
  // ];